export enum ROUTE_TYPES {
  ONE_WAY = 'oneWay',
  TWO_WAY = 'twoWay',
  NO_DIRECTION = 'noDirection'
}
